module.exports = __webpack_public_path__ + "img/arrow-down.fd8ec1a3.svg";